<template>
    <AccountInfo></AccountInfo>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const AccountInfo = defineAsyncComponent(() =>
    import("../../components/ITDepartment/AccountInfo.vue")
);

export default {
    name: "Account_Info", //The name you are in should not equal the name of the component you are importing.
    components: { AccountInfo, AuthLayout },
};
</script>
